"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _auth = require("@/utils/auth");
var _product = require("@/api/product");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// import exportExcel from '@/utils/newToExcel.js';
var _default2 = exports.default = {
  name: 'addCarMy',
  props: {
    cloudDisk: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      cloudDiskShow: false,
      CloudDiskValidateForm: {
        linkUrl: ''
      }
    };
  },
  created: function created() {
    // this.getToken();
  },
  watch: {
    cloudDisk: {
      handler: function handler(nVal, oVal) {
        this.CloudDiskValidateForm.linkUrl = nVal;
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.CloudDiskValidateForm.linkUrl = this.cloudDisk;
  },
  methods: {
    //保存
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$emit('handlerSubSuccess', _this.CloudDiskValidateForm.linkUrl);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancel: function cancel() {
      this.$emit('closeCloudDisk');
    }
  }
};